// NEVER PUT SECRETS IN THIS FILE

import brandToColor from '@/lib/brand-to-color'

const config = (instance) => {
  return {
    defaults: {
      sentryDsn:
        'https://44c60de37d5b4b32b525845bd5d3c95c@o36550.ingest.sentry.io/5993236',
      reCaptchaSiteKey: '6LcGJ2gcAAAAAJNM5nhP2O0WIzdQ7XPhzwQ7yRr1',
      gtmId: '',
      piano: {
        apiPath: 'https://api-eu.piano.io/api/v3'
      },
      environment: 'staging',
      meta: {
        titleTemplate: `%s | ${instance.name}`,
        description: instance.strapline,
        twitter: {
          cardType: 'summary_large_image',
          site: `@${instance.twitterId}`
        },
        googleSiteVerification: null,
        locale: 'en_GB',
        themeColor: brandToColor(instance.theme) || '#202121',
        title: instance.name,
        twitterHandle: `@${instance.twitterId}`
      },
      production: {
        gtmId: '',
        environment: 'production',
        piano: {
          apiPath: 'https://api-eu.piano.io/api/v3'
        }
      }
    }
  }
}

const envConfig = (instance) => {
  const env = process.env.NODE_ENV
  return { ...config(instance).defaults, ...config(instance)[env] }
}

export default envConfig
